import type { SelectHTMLAttributes } from "react";
import { Field, Select } from "../../components/ui.js";

/** Angel 2026-09-14: only these degrees. Legacy values stay as an extra option. */
export const HIGHEST_DEGREE_OPTIONS = [
  "PhD",
  "DrPH",
  "DO",
  "MBBS",
  "JD",
  "EdD",
  "MD",
] as const;

export function HighestDegreeField({
  value,
  onChange,
  required,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
}): JSX.Element {
  const known = new Set<string>(HIGHEST_DEGREE_OPTIONS);
  const extra = value && !known.has(value) ? value : null;
  const selectProps: SelectHTMLAttributes<HTMLSelectElement> = {
    value,
    required,
    disabled,
    onChange: (e) => onChange(e.target.value),
  };
  return (
    <Field label="Highest degree" required={required}>
      <Select {...selectProps}>
        <option value="">Select…</option>
        {extra ? <option value={extra}>{extra}</option> : null}
        {HIGHEST_DEGREE_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </Select>
    </Field>
  );
}
